import { Map } from 'immutable'
import { AsyncState, loadingAsyncState, unloadedAsyncState } from 'widgets-for-react'
import { getTags } from '../drupal/api.mod'
import { getDrupalLanguage } from '../drupal/types_and_parser/extra_types.mod'
import { bimAndDrawingsFormState, emptyBimAndDrawingsForm } from './custom_pages/request_documents'
import { SearchOverviewState } from './custom_pages/search_overview'
import { FooterState, initialFooterState } from './footer/state'
import { HeaderState, initialHeaderState } from './header/state'
import { tagToTaxonomy, vacancyCountry, vacancyDepartment } from './overview/utils'
import { PressReleaseState } from './pressRelease/state'
import { RouteState } from './route/state'
import { getLangFromUrl } from './utils/history.mod'

export type PublicSiteState = {
  route: RouteState
  header: HeaderState
  footer: FooterState
  press: PressReleaseState
  requestDocuments: { bimAndDrawingsFormState: bimAndDrawingsFormState }
  search_overview: SearchOverviewState
  departments: AsyncState<string[]>
  countries: AsyncState<string[]>
}

export const initialPublicSiteState = (): PublicSiteState => ({
  route: { kind: '404' },
  header: initialHeaderState,
  footer: initialFooterState(),
  press: unloadedAsyncState(),
  requestDocuments: { bimAndDrawingsFormState: emptyBimAndDrawingsForm() },
  search_overview: { overview_page: 0, current_query: '', get_searches: unloadedAsyncState() },
  departments: loadingAsyncState(() =>
    getTags(getDrupalLanguage(getLangFromUrl()), tagToTaxonomy(vacancyDepartment), Map())
  ),
  countries: loadingAsyncState(() => getTags(getDrupalLanguage(getLangFromUrl()), tagToTaxonomy(vacancyCountry), Map()))
})
